module.exports = __webpack_public_path__ + "teqbahn-assets/media/banner.e1967621.png";